import React from 'react';

/**
 * CardTable
 * A wrapper component that applies card-like styling to tables on mobile devices 
 */
const CardTable = ({ children, className = '' }: React.PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={`w-full box-border rounded-lg border border-gray-200 bg-white shadow-sm p-0! sm:p-0! sm:border-0 sm:shadow-none sm:rounded-none ${className}`}
    >
      {children}
    </div>
  );
};

export default CardTable;
